module.exports = __webpack_public_path__ + "img/our_m1.31a6748b.jpg";